import { Config } from "../../config";

let CDN_URL = Config.Cdn_Url;

const liveRoomRelativePath = `${CDN_URL}/liveroom`;

export const Images: { [key: string]: string } = {
  iconChingariLogo: `${liveRoomRelativePath}/chingari-logo.webp`,
  iconChingariFireLogo: `${liveRoomRelativePath}/chingari-fire-icon.svg`,
};
